import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { SavePaymentMethod } from '../../types/Types';

interface useGetBillingProps {
  userId: string;
  enabled?: boolean;
}

export function useGetBilling({ userId, enabled = true }: useGetBillingProps) {
  return useQuery({
    enabled,
    queryKey: ['userbilling', userId],
    queryFn: async () => {
      return axiosInstance<SavePaymentMethod[]>(getAPIURL(`/Billing/${userId}/`)).then(
        (response) => response.data,
      );
    },
  });
}